import * as ReactService from "@intech/react-service";
import { FichaFinanceiraEntidade } from "../entidades/FichaFinanceiraEntidade";
import { SaldoContribuicoesEntidade } from "../entidades/SaldoContribuicoesEntidade";
import { WebCapitalSeguradoEntidade } from "../entidades/WebCapitalSeguradoEntidade";

class FichaFinanceira extends ReactService.BaseService {
  constructor() {
    super("FichaFinanceira");
  }

  BuscarPorPlano = (cdPlano: string) =>
    this.CreateRequest<SaldoContribuicoesEntidade>(ReactService.RequestType.GET, `BuscarPorPlano/${cdPlano}`);

  BuscarUltimaExibicaoPorPlano = (cdPlano: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarUltimaExibicaoPorPlano/${cdPlano}`);

  BuscarDatasExtrato = (cdPlano: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarDatasExtrato/${cdPlano}`);

  BuscarCapitalSegurado = () =>
    this.CreateRequest<WebCapitalSeguradoEntidade[]>(ReactService.RequestType.GET, `BuscarCapitalSegurado`);

  GerarExtrato = (cdPlano: string, dtaInicio: string, dtaFim: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarExtrato/${cdPlano}/${dtaInicio}/${dtaFim}`, null, ReactService.ResponseType.Blob);

  BuscarDatasInforme = () =>
    this.CreateRequest<FichaFinanceiraEntidade[]>(ReactService.RequestType.GET, `BuscarDatasInforme`);

  BuscarInformePorAno = (ano: string) =>
    this.CreateRequest<any[]>(ReactService.RequestType.GET, `BuscarInformePorAno/${ano}`);

  GerarDeclaracaoIR = (ano: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarDeclaracaoIR/${ano}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const FichaFinanceiraService = new FichaFinanceira();
